import { Component } from 'preact'
import getWithInMemoryCache from '../../utils/getWithInMemoryCache'
import globals from '../../utils/globals'
import { SEARCH_TOKEN_URL } from '../../libs/config'
import { InstantSearch, Configure } from 'react-instantsearch-dom'
import SuggestedTopicsListContainer from './SuggestedTopicsListContainer'
import CustomSearchBox from './SearchBox'

class TopicSuggestion extends Component {
  constructor () {
    super()
    this.communityId = globals('communityId')
    this.state = {
      hideSuggestions: true
    }
  }
  componentDidMount () {
    getWithInMemoryCache(SEARCH_TOKEN_URL, {}).then(data => this.setState({
      clientId: data['client_id'],
      token: data.token
    }))
  }
  render (props, state) {
    if (!state.clientId || !state.token) return null
    return (
      <div className='topic-create_suggestions-wrapper'>
        <InstantSearch
          appId={state.clientId}
          apiKey={state.token}
          indexName={this.communityId}
        >
          <Configure
            hitsPerPage={7}
            analyticsTags={['destination', 'topic creation suggestion']}
          />
          <CustomSearchBox
            defaultCdn={props.defaultCdn}
            hideSuggestionsCallback={(value) => this.setState({ hideSuggestions: value })}
          />
          {
            !state.hideSuggestions && <SuggestedTopicsListContainer />
          }
        </InstantSearch>
      </div>
    )
  }
}

export default TopicSuggestion
